import ExcelJS from "exceljs";
import {
  applyImportDigiKeyColumns,
  applyObsoleteAlternateFromExcelLine,
  applyUnmatchedAlternateFromExcelLine,
  getFreightTotalFromDetails,
  getTariffTotalFromDetails,
  isBlankBomLine,
  organizeBomByMountingType,
  parseExcelRowsToBomlines,
} from "../constants/digiKeyColumns";
import { applySavedAttritionToBomlines } from "../constants/quoteQuantities";

export async function loadStructuredBomlinesForBom({
  token,
  bomId,
  getBomDetails,
  getFile,
  getDigiKeyBomEnrichment,
}) {
  const bomDetails = await getBomDetails(token, bomId);
  const freightTotal = getFreightTotalFromDetails(bomDetails?.data?.freight_details);
  const tariffTotal = getTariffTotalFromDetails(bomDetails?.data?.tariff_details);

  let bomFilePath = bomDetails?.data?.result_file_path
    ? bomDetails?.data?.result_file_path
    : bomDetails?.data?.file_path;

  if (!bomFilePath) {
    return {
      bomDetails,
      structuredBomlines: [],
      freightTotal,
      tariffTotal,
    };
  }

  const bomFile = await getFile(token, bomFilePath);
  if (!bomFile) {
    return {
      bomDetails,
      structuredBomlines: [],
      freightTotal,
      tariffTotal,
    };
  }

  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(bomFile);
  const bomLines = workbook._worksheets.find((worksheet) => worksheet?._rows)?._rows;

  let parsed = parseExcelRowsToBomlines(bomLines || [])
    .map((line, index) => ({
      ...applyUnmatchedAlternateFromExcelLine(
        applyObsoleteAlternateFromExcelLine(line),
      ),
      _bomLineIndex: index,
    }))
    .filter((line) => !isBlankBomLine(line));

  const enrichResponse = await getDigiKeyBomEnrichment(token, bomId);
  if (
    enrichResponse?.code >= 200 &&
    enrichResponse?.code < 400 &&
    enrichResponse?.data
  ) {
    parsed = applyImportDigiKeyColumns(parsed, enrichResponse.data);
  } else {
    parsed = organizeBomByMountingType(parsed);
  }

  let lineAttrition = bomDetails?.data?.line_attrition_quantities;
  if (typeof lineAttrition === "string") {
    try {
      lineAttrition = JSON.parse(lineAttrition);
    } catch (e) {
      lineAttrition = [];
    }
  }

  const quotes = bomDetails?.data?.quote || [];
  if (Array.isArray(lineAttrition) && lineAttrition.length && quotes.length) {
    parsed = applySavedAttritionToBomlines(parsed, quotes, lineAttrition);
  }

  return {
    bomDetails,
    structuredBomlines: parsed,
    freightTotal,
    tariffTotal,
  };
}
